<template>
    <td colspan="3" style="text-align: center; color: red; font-weight: bold">
        Campaign Deleted
    </td>
</template>

<script>
export default {
    props: [
        'data'
    ]
}
</script>